import {JsonClassType, JsonProperty, ObjectMapper} from '@outfoxx/jackson-js';
import {JsonClassTypeOptions, JsonParserContext} from '@outfoxx/jackson-js/dist/@types';
import {PageIdentity} from 'modules/spravochnik/dt-front-page-generator/src/Entity/Page';
import {PageItemInterface} from 'modules/spravochnik/dt-front-page-generator/src/Entity/index';

export class BasePageItem implements PageItemInterface {
    @JsonProperty()
    id: string;

    @JsonProperty()
    name: string;

    @JsonProperty()
    @JsonClassType(<JsonClassTypeOptions>{type: () => [PageIdentity]})
    pageIdentity: PageIdentity;

    @JsonProperty()
    card: any;

    public static createByObj(object: object | null): PageItem {
        if (!object) {
            throw new Error();
        }

        const objectMapper = new ObjectMapper();
        return objectMapper.parse<PageItem>(JSON.stringify(object), {mainCreator: () => [PageItem]} as JsonParserContext);
    }

    getUrl(): any {
        return {
            name: 'page-item',
            params: {
                itemId: this.id,
                pageUrlName: this.pageIdentity.pageUrlName,
                categoryUrlName: this.pageIdentity.categoryUrlName
            }
        };
    }
}


export class PageItem implements PageItemInterface {
    @JsonProperty()
    id: string;

    @JsonProperty()
    name: string;

    @JsonProperty()
    @JsonClassType(<JsonClassTypeOptions>{type: () => [PageIdentity]})
    pageIdentity: PageIdentity;

    @JsonProperty()
    card: any;

    public static createByObj(object: object | null): PageItem {
        if (!object) {
            throw new Error();
        }

        const objectMapper = new ObjectMapper();
        return objectMapper.parse<PageItem>(JSON.stringify(object), {mainCreator: () => [PageItem]} as JsonParserContext);
    }

    getUrl(): any {
        return {
            name: 'page-item',
            params: {
                itemId: this.id,
                pageUrlName: this.pageIdentity.pageUrlName,
                categoryUrlName: this.pageIdentity.categoryUrlName
            }
        };
    }
}
